import { MovieOpenPlusIcon } from './MovieOpenPlusIcon';

/**
 * author: Colton Wiscombe
 * id C9068163-63A6-44B7-BE11-2FCE6B427CF6
 * name movie-open-plus
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-plus.svg
 * tags
 * - Video / Movie 
 */
export const SlateOpenPlusIcon = MovieOpenPlusIcon;
export default SlateOpenPlusIcon